import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetProjectsAllSuspense } from '@/context/services/projects/Projects.service';
import { Project } from 'ap-openapi';

export const useFindProjects = () => {
  const items = useGetProjectsAllSuspense();
  const findById = useFindById<Project, 'id', 'display_name'>(items, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });
  const findByName = useFindByName<Project, 'display_name', 'id'>(items, {
    key: 'display_name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findProjectsById: findById,
    findProjectsByName: findByName,
  };
};
